import React, { useEffect, useRef } from "react";

const EtNoCopyWrapper = ({ children }) => {

  // First Created – 30 Nov 2025
  // Author – Atul Pandey
  // Purpose – Stricter protection wrapper to prevent copying, saving, dragging, and selecting content inside the wrapped block.  

  // 1 - Wrapper Ref
  const wrapperRef = useRef(null);

  // 2 - No copy mask
  useEffect(() => {
    const el = wrapperRef.current;

    if (!el) return;

    // Disable right-click
    const disableContextMenu = (e) => e.preventDefault();
    el.addEventListener("contextmenu", disableContextMenu);

    // Disable drag
    const disableDrag = (e) => e.preventDefault();
    el.addEventListener("dragstart", disableDrag);

    // Disable long press on mobile
    const disableTouchMenu = (e) => {
      if (e.touches && e.touches.length > 1) {
        e.preventDefault();
      }
    };
    el.addEventListener("touchstart", disableTouchMenu, { passive: false });

    return () => {
      el.removeEventListener("contextmenu", disableContextMenu);
      el.removeEventListener("dragstart", disableDrag);
      el.removeEventListener("touchstart", disableTouchMenu);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className="relative select-none"
      style={{
        WebkitUserSelect: "none",
        userSelect: "none",
        position: "relative",
      }}
    >
      {/* Actual content (images, text, JSX) */}
      <div className="pointer-events-none relative z-10">
        {children}
      </div>

      {/* Transparent overlay that blocks all interactions */}
      <div
        className="absolute inset-0 z-20"
        style={{
          background: "transparent",
          WebkitUserSelect: "none",
          userSelect: "none",
          pointerEvents: "auto",
        }}
      ></div>
    </div>
  );
};

export default EtNoCopyWrapper;